import React from 'react';
import { cn } from '@/shared/utils/cn';
import { Avatar } from '@/modules/Avatar';
import { Button } from '@/modules/Button';
import { ListItemUser } from '@/modules/Lists';
import { SidebarUserProfileProps } from '../../types';
import { SidebarDivider } from '../atoms';
import { faArrowRightToBracket } from '@fortawesome/pro-regular-svg-icons';
import { AvatarProps } from '@/modules/Avatar/types';

/**
 * ============================================
 * SIDEBAR USER PROFILE - MOLECULE
 * ============================================
 * Sección del perfil del usuario con avatar, nombre, rol
 * y botón de logout.
 *
 * Reutiliza el componente ListItemUser para mantener DRY.
 */
export const SidebarUserProfile: React.FC<SidebarUserProfileProps> = ({
  name,
  role,
  avatarProps,
  onLogout,
  className,
}) => {
  // Renderizar avatar usando el componente Avatar
  const renderAvatar = () => {
    const avatarType = avatarProps?.type || 'people';
    const { type, ...restAvatarProps } = avatarProps || {};
    return <Avatar {...({ type: avatarType, size: 'md', ...restAvatarProps } as AvatarProps)} />;
  };

  return (
    <div className={cn('ui-flex ui-w-full ui-flex-col ui-gap-8', className)}>
      {/* Info del perfil usando ListItemUser */}
      <ListItemUser
        name={name}
        subtitle={role}
        avatar={renderAvatar()}
        className="ui-h-auto ui-px-0 ui-py-0"
      />

      {/* Divider */}
      <SidebarDivider />

      {/* Botón de logout */}
      <Button
        theme="solid"
        color="tertiary"
        size="sm"
        fullWidth
        leftSlot={faArrowRightToBracket}
        onClick={onLogout}
      >
        Cerrar sesión
      </Button>
    </div>
  );
};
